import { Badge, Center, Paper, Stack, Title } from "@mantine/core";
import { IconFingerprint } from "@tabler/icons-react";
import type * as React from "react";
import { env } from "../env";
import { PANEL_COLOR, PANEL_RADIUS, PANEL_SPACE } from "../ui/tokens";

/** The signed-out card (Figma 15185:4862 and siblings): 450px, 30px in; 8px corners
 * (`radius/md`, Dan 2026-10-02, over the frames' 16px). */
const CARD = { width: 450, radius: PANEL_RADIUS.button, padding: 30 };

/**
 * The centered card every signed-out page uses (A8): the fingerprint, the title (22px
 * semibold Inter), then the page's content, left-aligned, 20px apart. Test builds show
 * their environment under the title (Dan 2026-10-02: kept, though the frames drop it).
 */
export function AuthCard({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <Center mih="100vh" p="md" bg={PANEL_COLOR.surface}>
      <Paper withBorder radius={CARD.radius} p={CARD.padding} w="100%" maw={CARD.width}>
        <Stack gap={PANEL_SPACE.page}>
          <Stack gap={PANEL_SPACE.field} align="center">
            <IconFingerprint size={24} stroke={2} color={PANEL_COLOR.brand} aria-hidden />
            <Title order={1} fz={22} fw={600} ta="center" lh="normal" style={{ letterSpacing: "-0.02em" }}>
              {title}
            </Title>
            {env.envLabel ? <Badge color="orange">{env.envLabel}</Badge> : null}
          </Stack>
          {children}
        </Stack>
      </Paper>
    </Center>
  );
}
